import { NavLink } from "react-router-dom";
import { Plus, X } from "lucide-react";
import type { BoardSummary } from "../api";
import { IconButton, Skeleton } from "./ui";

interface BoardRailProps {
  boards: BoardSummary[];
  loading: boolean;
  /** Only meaningful on a phone, where the rail slides over the workspace (§21.1). */
  open: boolean;
  onClose: () => void;
  onCreate: () => void;
}

/** A board is one thread of iterative work, so the rail is the list of threads, newest first. */
export function BoardRail({ boards, loading, open, onClose, onCreate }: BoardRailProps) {
  return (
    <>
      {/* Tapping beside a sheet closes it. The scrim is styled only at phone widths, so it is
          rendered only while the rail is genuinely an overlay. */}
      {open && (
        <button
          type="button"
          className="rail-scrim"
          aria-label="Close the board list"
          onClick={onClose}
        />
      )}

      <nav className={open ? "rail is-open" : "rail"} aria-label="Boards">
        <div className="rail-header">
          <h2 className="section-title">Boards</h2>
          <div className="row">
            <IconButton onClick={onCreate} label="New board">
              <Plus size={16} />
            </IconButton>
            {open && (
              <IconButton onClick={onClose} label="Close the board list">
                <X size={16} />
              </IconButton>
            )}
          </div>
        </div>

        <div className="rail-list">
          {loading && boards.length === 0 && (
            <>
              <Skeleton height={50} />
              <Skeleton height={50} />
              <Skeleton height={50} />
            </>
          )}

          {boards.map((board) => (
            <NavLink
              key={board.id}
              to={`/b/${board.id}`}
              className={({ isActive }) => (isActive ? "rail-item is-active" : "rail-item")}
              onClick={onClose}
            >
              {board.cover_thumb_url ? (
                <img className="rail-thumb" src={board.cover_thumb_url} alt="" />
              ) : (
                <span className="rail-thumb" aria-hidden />
              )}
              <span className="rail-item-text">
                <span className="rail-item-title">{board.title}</span>
                <span className="stamp">
                  {board.generation_count} {board.generation_count === 1 ? "frame" : "frames"}
                </span>
              </span>
            </NavLink>
          ))}
        </div>
      </nav>
    </>
  );
}
